<template>
    <footer>
        <div id="main_footer">
            <div class="container">
                <div class="row">
                    <div class="three columns">
                        <h4>Links</h4>
                        <nav>
                            <ul>
                                <!--<li>-->
                                    <!--<router-link class="menu-item" to="/policy/cookie">-->
                                        <!--Cookie policy-->
                                    <!--</router-link>-->
                                <!--</li>-->
                                <li>
                                    <router-link class="menu-item" to="/policy/privacy">
                                        Privacy policy
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="three columns">
                        <h4>Sitemap</h4>
                        <nav>
                            <ul>
                                <li>
                                    <router-link class="menu-item" to="/">
                                        Home
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/services">
                                        Diensten
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/about">
                                        Over ons
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/vacancies">
                                        Vacatures
                                    </router-link>
                                </li>
                                <li>
                                    <router-link class="menu-item" to="/contact">
                                        Contact
                                    </router-link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="three columns">
                        <h4>Contact</h4>
                        <ul class="contacts">
                            <li>
                                Goaijengeamieden 9
                            </li>
                            <li>
                                8628 SJ Go&euml;nga
                            </li>
                            <li style="margin-top: 24px;">
                                <a href="mailto:info@swbase.com">
                                    info@swbase.com
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="three columns">
                        <h4>Volg ons op</h4>
                        <a class="sicon" href="https://www.linkedin.com/company/swbase-systems-b-v-/">
                            <font-awesome-icon :icon="['fab', 'linkedin']" fixed-width/>
                        </a>
                        <a class="sicon" href="https://www.facebook.com/SwBase/">
                            <font-awesome-icon :icon="['fab', 'facebook-f']" fixed-width/>
                        </a>
                        <a class="sicon" href="https://www.instagram.com/swbase_bv/">
                            <font-awesome-icon :icon="['fab', 'instagram']" fixed-width/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div id="sub_footer">
            <div class="container">
                <div class="row">
                    <div class="one-half column">
                        &copy; Copyright {{year}} - SwBase Systems BV
                    </div>
                    <div class="one-half column" style="text-align: right;">
                        Mei grutskens makke yn Frysl&acirc;n
                        <img src="../assets/frysian_flag.png" class="fryslan" width="50" height="35"
                             alt="Frysl&acirc;n Boppe!"/>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faLinkedin, faFacebookF, faInstagram} from '@fortawesome/free-brands-svg-icons';

    library.add(faLinkedin, faFacebookF, faInstagram);

    export default {
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    }

</script>

<style scoped="scoped">
    footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-top: auto;
    }

    #main_footer {
        background-color: #F5F5F5;
        padding: 30px 0;
    }

    #sub_footer {
        background-color: #EEEEEE;
        padding: 15px 0;
    }

    h4 {
        text-transform: uppercase;
        font-weight: 400;
    }

    h4, #sub_footer {
        color: #BDBDBD;
        font-size: 20px;
        font-weight: 400;
    }

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    ul li, .sicon {
        color: #BCBCBC;
        font-size: 20px;
        font-weight: 300;
        margin-bottom: 2px;
    }

    .sicon {
        font-size: 24px;
    }

    ul a {
        color: inherit;
        text-decoration: none;
    }

    ul a:hover {
        color: #47A8E6;
    }

    .fryslan {
        width: 25px;
        height: auto;
    }

    #main_footer .columns{
        margin-bottom: 60px;
    }
</style>